import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useWindowSize from '../../../../utils/useWindowSize';
import styles from './RefundModal.module.scss';
import ConfirmSecondaryModal from '../../../Common/ConfirmSecondaryModal';
import { Button } from '@mui/material';
import * as yup from 'yup';
import { Field, Form, Formik } from 'formik';
import clsx from 'clsx';
import TextField from 'Containers/Common/TextField';
import { paymentActions } from 'Containers/Payments/store';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const RefundModal = ({ refundInformation = {}, closeModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const [refundData, setRefundData] = useState(undefined);

  const initialValues = {
    description: '',
  };
  const validationSchema = {
    description: yup.string().optional(),
  };
  const refund = () => {
    dispatch(
      paymentActions.REQUEST_REFUND.REQUEST(
        {
          idTransazione: refundInformation.idTransazione,
          importo: refundInformation.importo,
        },
        closeModal,
      ),
    );
  };
  return (
    <>
      <ConfirmSecondaryModal
        isModalOpen={!!refundData}
        setIsModalOpen={() => setRefundData}
        title={t('payments.refundModal.title')}
        subtitle={t('payments.refundModal.subtitle', {
          clientName: refundInformation?.clientName,
          amount: refundInformation?.importo,
          date: dayjs(refundInformation?.created_at).format('DD/MM/YYYY')
        })}
        buttons={[t('payments.refundModal.buttons.yes')]}
        buttonsActions={[refund]}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape(validationSchema)}
        onSubmit={(values) => {
          setRefundData(values);
        }}
      >
        {({ values, setFieldValue, errors, touched, setFieldTouched }) => (
          <Form className={styles.form}>
            <div className={styles.body}>
              <h4>{t('payments.refundModal.amountToRefund')}</h4>
              <p>{t('payments.refundModal.cardInfo')}</p>
              <Field
                name='description'
                id='description'
                placeholder={t('payments.refundModal.optionalNote')}
                component={TextField}
                type='text'
                height={'50px'}
                width={'100%'}
                margin={'20px 0'}
              />
              <p>{t('payments.refundModal.availableForRefund', { amount: '351,99' })}</p>
            </div>
            <hr />
            <div className={styles.footer}>
              <Button type={'submit'} className={styles.button}>
                {t('payments.refundModal.refund')}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default RefundModal;
